module.exports = __webpack_public_path__ + "media/images/svg/youtube-white-fe3c2fc770873378984142a1db72b6f8.svg";